<div class="toggle-container" (click)="toggle()">
  <div class="toggle-value" [class.is-off]="!isOn"></div>
</div>
